import React, { useState } from "react";

function RejectPopup({ show,onCancel, onReject, transaction_id }) {
  const [remarks, setRemarks] = useState("");


  const handleSubmit = () => {
    if (!remarks.trim()) {
      alert("Remarks are required to reject the transaction.");
      return;
    }
    onReject(transaction_id, remarks.trim());
    setRemarks("");
  };

  const handleCancel = () => {
    onCancel();
    setRemarks("");
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div style={{ background: "white", padding: 20, borderRadius: 8 }}>
            <h5>Enter Remarks for Team C</h5>
            <p>for transaction {transaction_id}</p>
            <textarea
              className="form-control"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              rows={3}
              autoFocus
            />
            <div className="mt-3 text-end">
              <button
                className="btn btn-secondary me-2"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button className="btn btn-danger" onClick={handleSubmit}>
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default RejectPopup;
